module.exports = "/images/vendor/flag-icon-css/flags/1x1/bb.svg?45c62450e2d60784a4f02d25e80e0b78";